import invariant from 'tiny-invariant'

interface ObjectItem {
  entityId: string
  userId: string
  /** Entity type determines the storage path segment. Images use /image/ for CloudFront edge-resize support. */
  entityType?: string
}

export const createObjectPath = (item: ObjectItem) => {
  const { userId, entityId, entityType } = item
  invariant(userId, 'User ID must be defined')
  invariant(entityId, 'Entity ID must be defined')
  const segment = entityType ?? 'storage'
  return `users/${item.userId}/${segment}/${item.entityId}`
}
